<gen-product-grid-item 
  [tooltipMessage]="tooltipMessage"
  [phoneNumberOrEmail]="phoneOrEmail"
  [product]="item"
  [gaListName]="gaListName"
  ></gen-product-grid-item>
